import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import Headroom from 'react-headroom';
import Header from './headerr'
import Footer from './footer'
import 'react-bootstrap-carousel/dist/react-bootstrap-carousel.css'
import '../scss/gatstrap.scss'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleRight,faCalendar } from '@fortawesome/free-solid-svg-icons';
library.add(faAngleRight,faCalendar);

if (typeof window !== "undefined") {
  require("smooth-scroll")('a[href*="#"]')
}
class Layout extends React.Component{
     componentDidMount() {
          const WOW = require("wowjs")
          new WOW.WOW().init();
          if(window.location.hash) {
            var hash = window.location.hash.substring(1);
            var elmnt = document.getElementById(hash);
            if(elmnt){
              elmnt.scrollIntoView();
            } else {}
          }
     }
     render() {
          return (
               <StaticQuery
                 query={graphql`
                   query SiteTitleQuery {
                     site {
                       siteMetadata {
                         title
                       }
                     }
                   }
                 `}
                 render={data => (
                   <>
                     <Helmet
                       title={data.site.siteMetadata.title}
                       meta={[
                         { name: 'description', content: 'Sample' },
                         { name: 'keywords', content: 'sample, something' },
                       ]}
                     >
                       <html lang="en" />
                     </Helmet>
                     <Header siteTitle={data.site.siteMetadata.title} />
                     <div className={this.props.className}>
                       {this.props.children}
                     </div>
                     <Footer />
                   </>
                 )}
               />
          );
     }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
